module.exports = __webpack_public_path__ + "img/part-4-3.e963a318.webp";